<template>
  <v-row>
    <v-col cols="0" md="12" sm="12" lg="12" xl="12" class="pt-0">
      <session-title class="pt-8 px-10 pb-5" title="Artigos" />
    </v-col>
    <v-col>
      <articles-grid />
    </v-col>
  </v-row>
</template>

<script>
import ArticlesGrid from '@/components/ArticlesGrid'
import SessionTitle from "@/components/SessionTitle";

export default {
  name: 'Articles',
  components: {
    'articles-grid': ArticlesGrid,
    "session-title": SessionTitle,
  }
}
</script>
